// src/services/index.ts
import axios from 'axios';
import moment from 'moment-timezone';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5001', // Fallback for development
  headers: {
    'Content-Type': 'application/json',
  },
  validateStatus: (status) => {
    if (status === 401) {
      // Clear auth data on Unauthorized status
      localStorage.removeItem('authToken');
      if ((window.location.pathname !== '/auth') && (window.location.pathname !== '/network-error')) {
        window.location.href = '/auth';
      }
      return false; 
    }
    // Allow handling of all statuses, except 5xx server errors
    return status >= 200 && status < 500;
  },
});

api.interceptors.request.use((config) => {
  const tz = moment.tz.guess();
  if (config.headers) {
    config.headers['X-Timezone'] = tz;
    config.headers['X-Project-Id'] = sessionStorage.getItem('selectedProjectId');
  }
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Add a flag to track network error state
let isHandlingNetworkError = false;

// Subscription endpoints that trigger user data refresh when successful
// Note: /checkout is excluded because user immediately redirects to Stripe payment page
const SUBSCRIPTION_MUTATION_ENDPOINTS = [
  '/subscription/v1/change-subscription',
  '/subscription/v1/cancel'
];

api.interceptors.response.use(
  response => {
    // Check if this is a successful subscription mutation - emit event to refresh user data
    const url = response.config.url || '';
    const isSubscriptionMutation = SUBSCRIPTION_MUTATION_ENDPOINTS.some(ep => url.includes(ep));
    const isStatusCheckSuccess = url.includes('/subscription/v1/status-check/') && response.status === 200;
    
    if ((isSubscriptionMutation || isStatusCheckSuccess) && response.status >= 200 && response.status < 300) {
      // Emit custom event for AuthContext to refresh user data
      window.dispatchEvent(new CustomEvent('subscription:updated'));
    }
    
    return response;
  },
  error => {
    // Only handle network errors if we're not already handling one
    if (!error.response && !isHandlingNetworkError) {
      isHandlingNetworkError = true;
      
      const lastPath = window.location.pathname + window.location.search;
      // Don't store lastPath if we're already on auth or network-error pages
      if (!['/auth', '/network-error'].includes(window.location.pathname)) {
        localStorage.setItem('lastPath', lastPath);
      }

      window.location.href = '/network-error';
    }
    return Promise.reject(error);
  }
);

export default api;
